import { Injectable } from '@angular/core';
import { OutletConfig } from '@hospitality-bot/entity';
import { ApiService } from '@hospitality-bot/shared/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService extends ApiService {
  getOutletConfig(
    config = { params: `?key=OUTLET_CONFIGURATION` }
  ): Observable<OutletConfig> {
    return this.get(`/api/v1/config${config.params ?? ''}`);
  }
}
